import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import type { FrameOwnerInfo } from "./useFrameOwners";

type Props = {
  info: FrameOwnerInfo | null | undefined;
  size?: "sm" | "md";
};

// mirrors FastestBadge + Tooltip in stats_page/AOTDLeaderboard.tsx
export function FrameOwnerBadge({ info, size = "sm" }: Props): JSX.Element | null {
  if (!info || info.count <= 0) return null;
  const tooltipText =
    info.count === 1
      ? `owns aotd-irl frame [${info.shortIds[0] ?? "?"}]`
      : `owns ${info.count} aotd-irl frames: ${info.shortIds.map((s) => `[${s}]`).join(" ")}`;
  return (
    <FrameBadge aria-label={tooltipText}>
      <FontAwesomeIcon icon={faImage} size={size === "sm" ? "sm" : "lg"} />
      <BadgeTooltip>{tooltipText}</BadgeTooltip>
    </FrameBadge>
  );
}

const FrameBadge = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  margin-left: 2px;
  padding: 0;
  line-height: 0;
  color: #b45309;
  filter: drop-shadow(0 0 2px rgba(245, 158, 11, 0.45))
    drop-shadow(0 0 5px rgba(245, 158, 11, 0.2));
  vertical-align: -0.12em;
  transition: color 0.15s ease, filter 0.15s ease;

  &:hover {
    color: #92400e;
    filter: drop-shadow(0 0 3px rgba(245, 158, 11, 0.55))
      drop-shadow(0 0 8px rgba(245, 158, 11, 0.28));
  }

  &:hover > span {
    visibility: visible;
    opacity: 1;
  }
`;

const BadgeTooltip = styled.span`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 9px);
  right: -4px;
  background-color: #1f1f1f;
  color: #fff;
  padding: 6px 10px;
  border-radius: 7px;
  font-size: 0.72rem;
  line-height: 1.35;
  max-width: 230px;
  width: max-content;
  white-space: normal;
  text-align: left;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.4);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;
  z-index: 200;
  transition: opacity 0.18s ease;
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 10px;
    border-width: 5px;
    border-style: solid;
    border-color: #1f1f1f transparent transparent transparent;
  }
`;
